// Product information.
// Gallery carousel, variant selection, the size guide modal and the accordions.

(function () {
  'use strict';

  // ---- a safety net for the form ----
  // If nextdev-product-form.js never loads, <nextdev-product-form> stays an unknown
  // the form submits natively. The input named "id" has to be enabled for that,
  // otherwise the POST goes without a variant and Shopify errors on "items".
  (function () {
    function enableVariantInputs() {
      document.querySelectorAll('[data-nextdev-variant-id][disabled]').forEach(function (input) {
        input.disabled = false;
      });
    }
    if (window.customElements && customElements.whenDefined) {
      var settled = false;
      customElements.whenDefined('nextdev-product-form').then(function () { settled = true; });
      // if it is still undefined once the page has loaded, drop the disabled flag
      window.addEventListener('load', function () {
        setTimeout(function () { if (!settled) enableVariantInputs(); }, 0);
      });
    } else {
      enableVariantInputs();
    }
  })();

  // ---- animated collapse sections (the accordions) ----
  var NextDevCollapse = (function () {
    var openPanels = [];

    function open(head, body, sign, openClass) {
      body.classList.add(openClass);
      head.setAttribute('aria-expanded', 'true');
      if (sign) sign.textContent = '−';
      body.style.maxHeight = body.scrollHeight + 'px';
      if (openPanels.indexOf(body) === -1) openPanels.push(body);
      var done = function (e) {
        if (e.propertyName !== 'max-height') return;
        if (body.classList.contains(openClass)) body.style.maxHeight = 'none';
        body.removeEventListener('transitionend', done);
      };
      body.addEventListener('transitionend', done);
    }

    function close(head, body, sign, openClass) {
      body.style.maxHeight = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.classList.remove(openClass);
      head.setAttribute('aria-expanded', 'false');
      if (sign) sign.textContent = '+';
      body.style.maxHeight = '0px';
      var i = openPanels.indexOf(body);
      if (i > -1) openPanels.splice(i, 1);
    }

    function bind(head, body, signSelector, openClass) {
      if (!head || !body || head.dataset.nextdevCollapseInit) return;
      head.dataset.nextdevCollapseInit = '1';
      var sign = head.querySelector(signSelector);
      body.style.maxHeight = '0px';
      head.addEventListener('click', function () {
        if (body.classList.contains(openClass)) {
          close(head, body, sign, openClass);
        } else {
          open(head, body, sign, openClass);
        }
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        openPanels.forEach(function (body) {
          body.style.maxHeight = 'none';
        });
      }, 150);
    });

    return { bind: bind };
  })();

  // ---- mouse drag for a horizontal scroller ----
  // A mouse has no way to swipe, so on a desktop the gallery and the thumbnail
  // strip are dragged. Only a mouse: a finger and a trackpad already scroll
  // them natively, and taking over their pointers would fight that.
  //
  // opts.snap(from, dx)  given the scroll position the drag started at and how
  //                      far it went, returns where to land - the main track
  //                      lands on a whole slide. Without it the drag is free.
  //
  // A drag longer than a few pixels swallows the click that follows it, so
  // letting go over a thumb or the video's buttons does not press them.
  function dragScroll(el, opts) {
    if (!el) return;
    opts = opts || {};
    var DRAG_START = 6;
    var start = null;
    var dragging = false;

    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      start = { x: e.clientX, left: el.scrollLeft, id: e.pointerId, t: Date.now() };
      dragging = false;
    });

    el.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var dx = e.clientX - start.x;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_START) return;
        dragging = true;
        try { el.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        el.classList.add('nextdev--pdp__dragging');
        // follow the pointer exactly: no snapping or smoothing while held
        el.style.scrollSnapType = 'none';
        el.style.scrollBehavior = 'auto';
      }
      el.scrollLeft = start.left - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!start || e.pointerId !== start.id) return;
      var s = start;
      start = null;
      if (!dragging) return;
      dragging = false;
      el.classList.remove('nextdev--pdp__dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }

      var dx = e.clientX - s.x;
      var restore = function () {
        el.style.scrollSnapType = '';
        el.style.scrollBehavior = '';
      };
      if (opts.snap) {
        var target = opts.snap(s.left, dx, Date.now() - s.t);
        el.style.scrollBehavior = 'smooth';
        el.scrollTo({ left: target, behavior: 'smooth' });
        // snapping back on before the glide ends would cut it short
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          el.removeEventListener('scrollend', finish);
          restore();
        };
        el.addEventListener('scrollend', finish);
        setTimeout(finish, 600);
      } else {
        restore();
      }

      // swallow the click this release would otherwise fire
      var swallow = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      };
      window.addEventListener('click', swallow, true);
      setTimeout(function () { window.removeEventListener('click', swallow, true); }, 0);
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }

  (function () {
    document.querySelectorAll('[data-nextdev-pdp]').forEach(function (root) {
      if (root.dataset.nextdevPdpInit) return;
      root.dataset.nextdevPdpInit = '1';

      // ---- gallery: main carousel <-> thumbs ----
      var track = root.querySelector('[data-nextdev-pdp-main]');
      var thumbsList = root.querySelector('[data-nextdev-pdp-thumbs]');
      // a media whose alt text says "hidden" stays in the markup but out of the
      // gallery, so it is left out of both lists and the indexes still line up.
      // What the page draws decides it, not the attribute, and the two lists are
      // read again on every interaction: css that puts a slide back, an a/b test
      // above all, gets a carousel that counts it, whenever that css arrives.
      var allThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-pdp-thumb]'));
      var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-pdp-slide]'));
      var thumbs = [];
      var slides = [];

      function drawn(list) {
        return list.filter(function (el) {
          return window.getComputedStyle(el).display !== 'none';
        });
      }

      // with one picture on show there is nothing to pick between, so the
      // strip goes; an offer whose run has more brings it back. A thumb keeps
      // its own display while the strip is hidden, so the count still holds.
      var thumbsWrap = thumbsList ? thumbsList.parentNode : null;

      function refresh() {
        thumbs = drawn(allThumbs);
        slides = drawn(allSlides);
        if (thumbsWrap) thumbsWrap.classList.toggle('nextdev--pdp__thumbs-wrap--one', thumbs.length < 2);
      }
      refresh();

      // the thumbnail strip drags freely with a mouse
      dragScroll(thumbsList);

      // Gallery by offer: the run of pictures on show, and what switches it.
      // See showRun below; with one run only it stays null.
      var galleryRun = 'single';
      var showRun = null;

      if (track && thumbs.length) {
        var activeIndex = 0;
        var syncing = false;
        var prevArrow = root.querySelector('[data-nextdev-pdp-prev]');
        var nextArrow = root.querySelector('[data-nextdev-pdp-next]');

        // an arrow that has nowhere to go is switched off
        function markArrows() {
          if (prevArrow) prevArrow.disabled = activeIndex <= 0;
          if (nextArrow) nextArrow.disabled = activeIndex >= thumbs.length - 1;
        }

        function markThumb(i) {
          refresh();
          if (i === activeIndex || i < 0 || i >= thumbs.length) return;
          activeIndex = i;
          thumbs.forEach(function (t) { t.classList.remove('nextdev--pdp__thumb--active'); });
          thumbs[i].classList.add('nextdev--pdp__thumb--active');
          markArrows();
          // keep the active thumb in view inside the strip
          if (thumbsList) {
            var t = thumbs[i];
            var left = t.offsetLeft - thumbsList.offsetLeft;
            var right = left + t.offsetWidth;
            if (left < thumbsList.scrollLeft) {
              thumbsList.scrollTo({ left: left - 16, behavior: 'smooth' });
            } else if (right > thumbsList.scrollLeft + thumbsList.clientWidth) {
              thumbsList.scrollTo({ left: right - thumbsList.clientWidth + 16, behavior: 'smooth' });
            }
          }
        }

        // on load the carousel lands on the selected variant's image
        var initialIndex = 0;
        for (var k = 0; k < thumbs.length; k++) {
          if (thumbs[k].classList.contains('nextdev--pdp__thumb--active')) { initialIndex = k; break; }
        }
        activeIndex = initialIndex;
        if (initialIndex > 0) {
          requestAnimationFrame(function () {
            var prev = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = initialIndex * track.clientWidth;
            requestAnimationFrame(function () {
              track.style.scrollBehavior = prev || '';
            });
          });
        }

        // clicking a thumb scrolls the main carousel
        allThumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            refresh();
            var i = thumbs.indexOf(thumb);
            if (i < 0) return;
            syncing = true;
            markThumb(i);
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
            setTimeout(function () { syncing = false; }, 400);
          });
        });

        // scrolling the main carousel marks the matching thumb
        var raf = null;
        track.addEventListener('scroll', function () {
          if (syncing || raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var w = track.clientWidth;
            if (!w) return;
            markThumb(Math.round(track.scrollLeft / w));
          });
        }, { passive: true });

        // lets the variant picker scroll the carousel to its image
        window.NextDevGoToMedia = function (scope, mediaId) {
          if (scope !== root) return;
          refresh();
          for (var i = 0; i < slides.length; i++) {
            if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
              syncing = true;
              markThumb(i);
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              setTimeout(function () { syncing = false; }, 400);
              return;
            }
          }
        };

        // Gallery by offer. The deal's and the bundle's pictures come after
        // this product's, each run marked with the Bundle block's row it
        // belongs to (data-nextdev-pdp-set), and only the picked row's run is
        // drawn. A new run starts on its first picture, at once: sliding there
        // from where the last run stood would pass pictures that are gone. A
        // row with no run of its own shows this product's. Answers whether
        // the run changed.
        var hasRuns = allSlides.some(function (s) {
          return s.getAttribute('data-nextdev-pdp-set') !== 'single';
        });
        if (hasRuns) {
          showRun = function (name) {
            var found = allSlides.some(function (s) {
              return s.getAttribute('data-nextdev-pdp-set') === name;
            });
            if (!found) name = 'single';
            if (name === galleryRun) return false;
            galleryRun = name;

            allSlides.concat(allThumbs).forEach(function (el) {
              var mine = el.getAttribute('data-nextdev-pdp-set') === name;
              if (mine) {
                el.removeAttribute('data-nextdev-pdp-off');
              } else {
                el.setAttribute('data-nextdev-pdp-off', '');
                el.classList.remove('nextdev--pdp__thumb--active');
              }
            });

            syncing = true;
            if (thumbsList) thumbsList.scrollLeft = 0;
            activeIndex = -1;
            markThumb(0);
            var prev = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = 0;
            requestAnimationFrame(function () {
              track.style.scrollBehavior = prev || '';
              syncing = false;
            });
            return true;
          };
        }

        // previous / next image beside the thumbnail strip
        function goTo(i) {
          refresh();
          if (i < 0 || i >= slides.length) return;
          syncing = true;
          markThumb(i);
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          setTimeout(function () { syncing = false; }, 400);
        }
        if (prevArrow) {
          prevArrow.addEventListener('click', function () { goTo(activeIndex - 1); });
        }
        if (nextArrow) {
          nextArrow.addEventListener('click', function () { goTo(activeIndex + 1); });
        }
        markArrows();

        // a mouse drags the carousel; letting go lands on a whole slide - the
        // next or previous one after a real pull (or a quick flick), otherwise
        // back on the one it started from
        dragScroll(track, {
          snap: function (from, dx, ms) {
            refresh();
            var w = track.clientWidth || 1;
            var startIndex = Math.round(from / w);
            var flick = ms < 250 && Math.abs(dx) > 30;
            var index = startIndex;
            if (Math.abs(dx) > w * 0.15 || flick) {
              index = dx < 0 ? startIndex + 1 : startIndex - 1;
            }
            index = Math.max(0, Math.min(slides.length - 1, index));
            return index * w;
          }
        });

        // on a width change we realign to the active slide
        var resizeT;
        window.addEventListener('resize', function () {
          clearTimeout(resizeT);
          resizeT = setTimeout(function () {
            syncing = true;
            track.scrollLeft = activeIndex * track.clientWidth;
            setTimeout(function () { syncing = false; }, 100);
          }, 150);
        });
      }

      // ---- the video in the gallery ----
      // A video starts on its own, muted, as soon as its slide is the one on
      // screen, and stops as soon as its slide is swiped away; there can be
      // more than one. A browser only lets a video start without a tap when it
      // is muted, so it starts muted and the button in the right corner turns
      // the sound on. The button in the left corner pauses and plays it again.
      // A line across the top says how far along it is.
      //
      // Once the sound is turned on it stays on for the other videos here: the
      // tap that turned it on is what lets them start with sound. Someone who
      // asked their device for less motion gets no video starting by itself.
      var videoSlides = root.querySelectorAll('[data-nextdev-pdp-video-slide]');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var soundOn = false;
      if (track && videoSlides.length) {
        videoSlides.forEach(function (slide) {
          var video = slide.querySelector('[data-nextdev-pdp-video]');
          var watch = slide.querySelector('[data-nextdev-pdp-watch]');
          var label = slide.querySelector('[data-nextdev-pdp-watch-label]');
          var progress = slide.querySelector('[data-nextdev-pdp-video-progress]');
          var mute = slide.querySelector('[data-nextdev-pdp-mute]');
          if (!video || !watch || !label || !progress) return;

          function offer(on) {
            watch.hidden = !on;
            if (mute) mute.hidden = !on;
          }

          function markSound() {
            if (!mute) return;
            mute.classList.toggle('nextdev--pdp__mute--on', !video.muted);
            mute.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
            mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          }

          // Starts the video with the sound the shopper chose. A browser that
          // refuses sound without a fresh tap still gets the video, muted.
          function autoplay() {
            if (reduceMotion || !video.paused) return;
            video.muted = !soundOn;
            var started = video.play();
            if (started && started.catch) {
              started.catch(function () {
                if (video.muted) return;
                video.muted = true;
                var again = video.play();
                if (again && again.catch) again.catch(function () {});
              });
            }
          }

          if (mute) {
            mute.addEventListener('click', function () {
              video.muted = !video.muted;
              soundOn = !video.muted;
              if (video.paused) {
                var started = video.play();
                if (started && started.catch) started.catch(function () {});
              }
            });
            video.addEventListener('volumechange', markSound);
            markSound();
          }

          function playing(on) {
            watch.classList.toggle('nextdev--pdp__watch--playing', on);
            watch.setAttribute('aria-pressed', on ? 'true' : 'false');
            label.textContent = on ? 'Pause video' : 'Watch video';
          }

          function mark() {
            var along = video.duration ? video.currentTime / video.duration : 0;
            progress.style.setProperty('--nextdev-pdp-progress', (along * 100).toFixed(2) + '%');
            progress.classList.toggle('nextdev--pdp__video-progress--on', along > 0 || !video.paused);
          }

          watch.addEventListener('click', function () {
            if (video.paused) {
              var started = video.play();
              if (started && started.catch) started.catch(function () { playing(false); });
            } else {
              video.pause();
            }
          });

          video.addEventListener('play', function () { playing(true); mark(); });
          video.addEventListener('pause', function () { playing(false); });
          video.addEventListener('timeupdate', mark);
          video.addEventListener('ended', function () {
            playing(false);
            video.currentTime = 0;
            mark();
          });

          if (!('IntersectionObserver' in window)) {
            offer(true);
            return;
          }

          // the buttons are offered, and the video plays, while its slide is
          // the one on screen
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                offer(true);
                autoplay();
              } else {
                video.pause();
                offer(false);
              }
            });
          }, { root: track, threshold: 0.6 }).observe(slide);
        });
      }

      // ---- variant selection ----
      // Every option the product carries is a group of buttons, and a click
      // matches the chosen values against product.variants. Nothing here knows
      // what the options are called or how many there are.
      var variantsEl = root.querySelector('[data-nextdev-variants]');
      var variants = [];
      if (variantsEl) {
        try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
      }

      var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-pdp-option-group]'));
      var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-nextdev-pdp-option]'));
      var idInput = root.querySelector('[data-nextdev-variant-id]');
      var atcBtn = root.querySelector('[data-nextdev-pdp-atc]');
      var atcText = root.querySelector('[data-nextdev-atc-text]');
      var soldOutMsg = root.querySelector('.sold-out-message');
      var atcNote = root.querySelector('[data-nextdev-pdp-atc-note]');
      var priceEl = root.querySelector('[data-nextdev-price]');
      var compareEl = root.querySelector('[data-nextdev-price-compare]');
      var saveEl = root.querySelector('[data-nextdev-save]');
      var noteEl = root.querySelector('[data-nextdev-price-note]');

      // the shop's own formatter, assets/nextdev-format-money.js, is what prices
      // go through. What follows it is only for a page that does not have it, a
      // preview above all
      var moneyTpl = window.NextDevMoneyTemplate || '$0';
      var zeroAt = moneyTpl.indexOf('0');
      var moneyPre = zeroAt > -1 ? moneyTpl.slice(0, zeroAt) : '$';
      var moneySuf = zeroAt > -1 ? moneyTpl.slice(zeroAt + 1) : '';

      function money(cents) {
        var rounded = Math.round(cents);
        // round sums show without decimals
        var format = rounded % 100 === 0 ? 'amount_no_decimals' : 'amount';

        var fn = window.formatMoney
          || (window.Shopify && Shopify.formatMoney)
          || null;

        if (fn) {
          try { return fn(rounded, format); } catch (e) { /* falls through */ }
        }

        var whole = String(Math.floor(rounded / 100))
          // the thousands separator the shop's own formatter puts in,
          // or this reads $2499 where the theme reads $2,499
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        var frac = rounded % 100;
        var amount = frac === 0
          ? String(whole)
          : whole + '.' + (frac < 10 ? '0' + frac : String(frac));
        return moneyPre + amount + moneySuf;
      }

      // the option's place in variant.options comes off the element, where
      // liquid writes the position the product gave it
      function posOf(el) {
        var p = parseInt(el.getAttribute('data-option-position'), 10);
        return (p > 0 ? p : 1) - 1;
      }

      // a swatch and a named button carry different families, so the state
      // class follows whichever one the button was drawn with
      function familyOf(btn) {
        return btn.classList.contains('nextdev--pdp__color')
          ? 'nextdev--pdp__color'
          : 'nextdev--pdp__size';
      }

      function chosenIn(group) {
        return group.querySelector('.nextdev--pdp__size--selected, .nextdev--pdp__color--selected');
      }

      function chosen() {
        var opts = [];
        optionGroups.forEach(function (group) {
          var btn = chosenIn(group);
          if (btn) opts[posOf(group)] = btn.getAttribute('data-value');
        });
        return opts;
      }

      // The same choice keyed by the option's own name, which is what a
      // snippet beside this one needs: a second product's options line up with
      // this product's by name, never by position.
      function chosenByName() {
        var named = {};
        optionGroups.forEach(function (group) {
          var btn = chosenIn(group);
          var name = group.getAttribute('data-option-name');
          if (btn && name) named[name] = btn.getAttribute('data-value');
        });
        return named;
      }

      // Said out loud on every change, so any number of snippets can follow
      // the choice. nextdevPdpOffer is one slot and the bundle has it; this is
      // for everything else.
      function announce(v) {
        if (typeof CustomEvent !== 'function') return;
        root.dispatchEvent(new CustomEvent('nextdev:pdp:variant', {
          bubbles: true,
          detail: { variant: v || null, options: chosenByName() }
        }));
      }

      // agrees with what is chosen in every option before `upto`, and says
      // nothing about the ones after it
      function agreesBefore(variant, opts, upto) {
        for (var j = 0; j < upto && j < opts.length; j++) {
          if (opts[j] != null && variant.options[j] !== opts[j]) return false;
        }
        return true;
      }

      function findVariant() {
        var opts = chosen();
        for (var i = 0; i < variants.length; i++) {
          if (agreesBefore(variants[i], opts, opts.length)) return variants[i];
        }
        return null;
      }

      // The options read left to right, the way Dawn's do. The first of several
      // is always offered whole, and every one after it is answered by what is
      // chosen before it: a value is open while some variant carries it, is in
      // stock, and agrees with those earlier options. What is chosen further
      // along does not narrow it, so a visitor is never left with a row where
      // nothing can be picked.
      //
      // A product with one option is the exception: nothing comes before it to
      // answer it, so it is marked on stock alone. Leaving it whole would say
      // every value can be bought when some cannot.
      function markAvailability() {
        var opts = chosen();
        var lone = optionGroups.length < 2;
        optionButtons.forEach(function (btn) {
          var pos = posOf(btn);
          var value = btn.getAttribute('data-value');
          var open = pos === 0 && !lone;
          for (var i = 0; !open && i < variants.length; i++) {
            var v = variants[i];
            if (v.options[pos] !== value || !v.available) continue;
            if (agreesBefore(v, opts, pos)) open = true;
          }
          btn.classList.toggle(familyOf(btn) + '--unavailable', !open);
        });
      }

      // same mechanism as the form script: swap the spans, not the text.
      // `variant` is the variant the button stands for (the one sold, after a
      // bundle swaps it): a sold out one can be watched for its return.
      function offerAdd(on, variant) {
        if (atcBtn) {
          atcBtn.disabled = !on;
          if (on) {
            atcBtn.removeAttribute('aria-disabled');
          } else {
            atcBtn.setAttribute('aria-disabled', 'true');
          }
        }
        if (atcText) atcText.classList.toggle('hidden', !on);
        if (soldOutMsg) soldOutMsg.classList.toggle('hidden', on);
        // the line under the button goes with the label: a sold out variant
        // has nothing to ship
        if (atcNote) atcNote.hidden = !on;
        notifyVariant = on ? null : (variant || null);
        markNotify();
      }

      // ---- back in stock ----
      // With the Pelsbarn Core app's Back in Stock embed on, a sold out
      // variant's button stays Sold out but can be pressed: it opens the
      // embed's window to leave an email, and Klaviyo writes when the variant
      // is back. It keeps aria-disabled, so the form still refuses to add it
      // and the floating bar still reads it as sold out; only `disabled` comes
      // off, so it takes a click. Without the embed nothing changes.
      var notifyLabel = root.querySelector('[data-nextdev-pdp-notify-label]');
      var notifyVariant = null;

      function backInStock() {
        var api = window.NextDevBackInStock;
        return api && typeof api.open === 'function' ? api : null;
      }

      function markNotify() {
        var api = backInStock();
        var on = !!(api && notifyVariant && atcBtn);
        if (atcBtn) {
          if (on) {
            atcBtn.disabled = false;
            atcBtn.setAttribute('data-nextdev-pdp-notify', '');
          } else {
            atcBtn.removeAttribute('data-nextdev-pdp-notify');
          }
        }
        if (notifyLabel) {
          if (on) notifyLabel.textContent = api.label || 'Notify me when back';
          notifyLabel.hidden = !on;
        }
      }

      if (atcBtn) {
        // capture, so the click never reaches the form as a submit
        atcBtn.addEventListener('click', function (event) {
          if (!atcBtn.hasAttribute('data-nextdev-pdp-notify')) return;
          var api = backInStock();
          if (!api || !notifyVariant) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          api.open(notifyVariant.id, notifyVariant.name);
        }, true);
      }

      // the embed may arrive after this script: it says so, and a sold out
      // button already on the page turns on then
      document.addEventListener('nextdev:back-in-stock-ready', markNotify);

      // TEMPORARY pre-order note: it shows for a few variants only, and the
      // order carries it as a line item property while it does. Delete this,
      // the markup marked the same way and the __preorder rules in the css when
      // they ship from stock.
      var preorder = root.querySelector('[data-nextdev-pdp-preorder]');
      var preorderProperty = root.querySelector('[data-nextdev-pdp-preorder-property]');

      function markPreorder() {
        if (!preorder) return;
        var picked = chosen();
        // A product whose every variant is a pre-order is asked no questions.
        // Otherwise: one entry per combination, entries split on |, the values
        // inside one split on ' / '. Every value of an entry has to be chosen,
        // so an entry of one value catches every variant with it and a longer
        // one names the combination exactly, whatever order it is written in.
        var on = preorder.hasAttribute('data-every') || (preorder.getAttribute('data-values') || '').split('|').some(function (combo) {
          var wanted = combo.split(' / ');
          return combo.trim() !== '' && wanted.every(function (value) {
            return picked.indexOf(value.trim()) > -1;
          });
        });
        preorder.hidden = !on;
        // a disabled field is not posted, so the order says pre-order for
        // those variants and says nothing for the rest
        if (preorderProperty) preorderProperty.disabled = !on;
      }

      function updateVariant() {
        markAvailability();
        markPreorder(); // TEMPORARY pre-order note

        var v = findVariant();
        announce(v);

        // the product has no such combination, so there is nothing to add
        if (!v) {
          offerAdd(false);
          if (root.nextdevPdpOffer) root.nextdevPdpOffer(v);
          return;
        }

        // Something else on the page can offer this product under another
        // variant, the bundle snippet above all. It is asked on every change
        // and answers with the variant to post, or nothing. The gallery still
        // follows the product's own variant.
        var sold = (root.nextdevPdpOffer && root.nextdevPdpOffer(v)) || v;

        if (idInput) idInput.value = sold.id;

        // the address keeps the choice across a reload or a share
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }

        if (priceEl) priceEl.textContent = money(sold.price);
        var hasCompare = sold.compare_at_price && sold.compare_at_price > sold.price;
        if (compareEl) {
          compareEl.textContent = hasCompare ? money(sold.compare_at_price) : '';
          compareEl.hidden = !hasCompare;
        }
        if (saveEl) {
          // A saving under half a percent rounds to nothing, and "Save 0%" is
          // worse than no badge at all. The struck price still shows, because
          // the variant really is cheaper.
          var savePct = hasCompare
            ? Math.round((sold.compare_at_price - sold.price) * 100 / sold.compare_at_price)
            : 0;
          saveEl.textContent = 'Save ' + savePct + '%';
          saveEl.hidden = savePct < 1;
        }
        if (noteEl) {
          if (hasCompare) {
            noteEl.textContent = 'Only ' + money(sold.price / 2) + ' per bed - save ' + money(sold.compare_at_price - sold.price) + ' today in total!';
            noteEl.hidden = false;
          } else {
            noteEl.hidden = true;
          }
        }

        offerAdd(sold.available, sold);

        // The gallery shows the pictures of the offer picked in the Bundle
        // block. A new offer starts on its product's first picture; after
        // that, a variant with its own image takes the carousel to it, the
        // image of the variant sold while that offer's pictures are on show.
        var offerName = typeof root.nextdevPdpOfferName === 'function' ? root.nextdevPdpOfferName() : 'single';
        var newRun = showRun ? showRun(offerName) : false;
        var shown = galleryRun === 'single' ? v : sold;
        if (!newRun && shown.featured_media && typeof window.NextDevGoToMedia === 'function') {
          window.NextDevGoToMedia(root, shown.featured_media.id);
        }
      }

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-nextdev-pdp-option-group]');
          if (!group) return;

          group.querySelectorAll('[data-nextdev-pdp-option]').forEach(function (other) {
            other.classList.remove(familyOf(other) + '--selected');
          });
          btn.classList.add(familyOf(btn) + '--selected');

          var label = group.querySelector('[data-nextdev-pdp-option-value]');
          if (label) label.textContent = btn.getAttribute('data-value') || '';

          // the limited label shows while the picked value is one of the
          // values the block marks, written as |Beige|Terracotta|
          var limitedTag = group.querySelector('[data-nextdev-pdp-limited-tag]');
          if (limitedTag) {
            var limitedList = limitedTag.getAttribute('data-values') || '';
            limitedTag.hidden = limitedList.indexOf('|' + (btn.getAttribute('data-value') || '') + '|') === -1;
          }

          updateVariant();
        });
      });

      // What the picker knows, published on the root so a snippet rendered
      // beside it can read the choice and ask for a redraw. See
      // snippets/product-bundle.
      root.nextdevPdpVariant = findVariant;
      root.nextdevPdpUpdate = updateVariant;
      root.nextdevPdpOptions = chosenByName;

      // on load only the buttons are marked. The price, the label and the
      // address are what liquid already rendered, and rewriting them here
      // would only risk formatting them differently.
      if (variants.length && optionButtons.length) markAvailability();

      // A page that opens on a sold out variant offers Back in Stock straight
      // away. No variant event fires on load, so the variant is the one the
      // form would post: the id liquid wrote, which is the one sold.
      if (idInput && variants.length) {
        for (var vi = 0; vi < variants.length; vi++) {
          if (String(variants[vi].id) === String(idInput.value)) {
            if (!variants[vi].available) notifyVariant = variants[vi];
            break;
          }
        }
        markNotify();
      }

      // ---- size guide modal ----
      // With Size guide entries it has a tab per size and the full guide
      // last, snippets/nextdev-pdp-size-guide.liquid. It opens on the size
      // chosen on the page, or on the full guide when none matches. A size's
      // video takes its source when its tab opens and plays with its sound,
      // since opening it is the visitor asking; it stops when the tab or the
      // window closes. "Choose this size" presses that size's own button in
      // the picker, so the page changes variant the way a click there does.
      var sgModal = root.querySelector('[data-nextdev-pdp-size-guide-modal]');
      if (sgModal) {
        var sgTabs = Array.prototype.slice.call(sgModal.querySelectorAll('[data-nextdev-pdp-size-guide-tab]'));
        var sgPanels = Array.prototype.slice.call(sgModal.querySelectorAll('[data-nextdev-pdp-size-guide-panel]'));
        var sgPosition = sgModal.getAttribute('data-size-position');

        var sgVideoOf = function (panel) {
          return panel ? panel.querySelector('[data-nextdev-pdp-size-guide-video]') : null;
        };

        var sgStopAll = function () {
          sgPanels.forEach(function (panel) {
            var v = sgVideoOf(panel);
            if (v && !v.paused) v.pause();
          });
        };

        // The sound is on until the shopper turns it off with the button in
        // the corner, and then stays off for the other sizes' videos too.
        var sgSoundOn = true;

        var sgPlay = function (video) {
          if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
          video.muted = !sgSoundOn;
          var started = video.play();
          // a browser that will not start it with sound starts it without;
          // a play cut short by a pause is not that, and keeps the sound
          if (started && started.catch) {
            started.catch(function (e) {
              if (!e || e.name !== 'NotAllowedError' || video.muted) return;
              video.muted = true;
              var again = video.play();
              if (again && again.catch) again.catch(function () {});
            });
          }
        };

        // the raised capsule sits under the open tab; offsetLeft is within
        // the row, so it holds when the row scrolls
        var sgThumb = sgModal.querySelector('[data-nextdev-pdp-size-guide-thumb]');
        var sgAt = -1;
        var sgMoveThumb = function () {
          var tab = sgTabs[sgAt];
          if (!sgThumb || !tab) return;
          sgThumb.style.width = tab.offsetWidth + 'px';
          sgThumb.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
          var row = tab.parentNode;
          if (tab.offsetLeft < row.scrollLeft || tab.offsetLeft + tab.offsetWidth > row.scrollLeft + row.clientWidth) {
            row.scrollTo({ left: tab.offsetLeft - (row.clientWidth - tab.offsetWidth) / 2, behavior: 'smooth' });
          }
        };
        window.addEventListener('resize', sgMoveThumb);

        var sgSelect = function (i, play) {
          sgStopAll();
          sgAt = i;
          sgTabs.forEach(function (tab, k) {
            var on = k === i;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            tab.classList.toggle('nextdev--size-guide__tab--active', on);
            if (sgPanels[k]) sgPanels[k].hidden = !on;
          });
          sgMoveThumb();
          var video = sgVideoOf(sgPanels[i]);
          if (video && play) sgPlay(video);
        };

        // the size chosen on the page, by its button's selected class
        var sgChosenSize = function () {
          if (!sgPosition || sgPosition === '0') return '';
          var on = root.querySelector('[data-nextdev-pdp-option][data-option-position="' + sgPosition + '"][class*="--selected"]');
          return on ? on.getAttribute('data-value') : '';
        };

        var openSizeGuide = function () {
          sgModal.classList.remove('nextdev--size-guide__modal--hidden');
          sgModal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
          if (sgTabs.length) {
            var want = (sgChosenSize() || '').toLowerCase();
            var at = -1;
            sgTabs.forEach(function (tab, k) {
              var size = tab.getAttribute('data-size');
              if (at < 0 && size && size.toLowerCase() === want) at = k;
            });
            // no match: the full guide, the last tab, which carries no size
            if (at < 0) at = sgTabs.length - 1;
            if (sgThumb) sgThumb.style.transition = 'none';
            sgSelect(at, true);
            if (sgThumb) {
              sgThumb.offsetWidth;
              sgThumb.style.transition = '';
            }
          }
        };
        var closeSizeGuide = function () {
          sgStopAll();
          sgModal.classList.add('nextdev--size-guide__modal--hidden');
          sgModal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflow-hidden');
        };

        sgTabs.forEach(function (tab, k) {
          tab.addEventListener('click', function () { sgSelect(k, true); });
          tab.addEventListener('keydown', function (e) {
            var to = -1;
            if (e.key === 'ArrowRight') to = (k + 1) % sgTabs.length;
            if (e.key === 'ArrowLeft') to = (k - 1 + sgTabs.length) % sgTabs.length;
            if (e.key === 'Home') to = 0;
            if (e.key === 'End') to = sgTabs.length - 1;
            if (to < 0) return;
            e.preventDefault();
            sgSelect(to, true);
            sgTabs[to].focus();
          });
        });

        // each video's controls are the gallery's: the button in the corner,
        // the line across the top, and a tap on the video does what the
        // button does
        sgPanels.forEach(function (panel) {
          var video = sgVideoOf(panel);
          if (!video) return;
          var watch = panel.querySelector('[data-nextdev-pdp-size-guide-watch]');
          var watchLabel = panel.querySelector('[data-nextdev-pdp-size-guide-watch-label]');
          var progress = panel.querySelector('[data-nextdev-pdp-size-guide-progress]');
          var playing = function (on) {
            watch.classList.toggle('nextdev--pdp__watch--playing', on);
            watch.setAttribute('aria-pressed', on ? 'true' : 'false');
            watchLabel.textContent = on ? 'Pause video' : 'Watch video';
          };
          var mark = function () {
            var along = video.duration ? video.currentTime / video.duration : 0;
            progress.style.setProperty('--nextdev-pdp-progress', (along * 100).toFixed(2) + '%');
            progress.classList.toggle('nextdev--pdp__video-progress--on', along > 0 || !video.paused);
          };
          var toggle = function () {
            if (video.paused) {
              sgPlay(video);
            } else {
              video.pause();
            }
          };
          var mute = panel.querySelector('[data-nextdev-pdp-size-guide-mute]');
          if (mute) {
            var markSound = function () {
              mute.classList.toggle('nextdev--pdp__mute--on', !video.muted);
              mute.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
              mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
            };
            mute.addEventListener('click', function () {
              video.muted = !video.muted;
              sgSoundOn = !video.muted;
            });
            video.addEventListener('volumechange', markSound);
          }
          watch.addEventListener('click', toggle);
          video.addEventListener('click', toggle);
          video.addEventListener('play', function () { playing(true); mark(); });
          video.addEventListener('pause', function () { playing(false); });
          video.addEventListener('timeupdate', mark);
          video.addEventListener('ended', function () {
            playing(false);
            video.currentTime = 0;
            mark();
          });
        });

        sgModal.querySelectorAll('[data-nextdev-pdp-size-guide-choose]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var value = btn.getAttribute('data-value');
            var options = root.querySelectorAll('[data-nextdev-pdp-option][data-option-position="' + sgPosition + '"]');
            for (var oi = 0; oi < options.length; oi++) {
              if (options[oi].getAttribute('data-value').toLowerCase() === value.toLowerCase()) {
                options[oi].click();
                break;
              }
            }
            closeSizeGuide();
          });
        });

        root.querySelectorAll('[data-nextdev-pdp-size-guide]').forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openSizeGuide();
          });
        });

        root.querySelectorAll('[data-nextdev-pdp-size-guide-close]').forEach(function (btn) {
          btn.addEventListener('click', closeSizeGuide);
        });

        // a click on the backdrop, outside the container, closes it
        sgModal.addEventListener('click', function (e) {
          if (e.target === sgModal) closeSizeGuide();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !sgModal.classList.contains('nextdev--size-guide__modal--hidden')) closeSizeGuide();
        });
      }

      // ---- accordions ----
      root.querySelectorAll('[data-nextdev-pdp-accordion]').forEach(function (head) {
        NextDevCollapse.bind(head, head.nextElementSibling, '.nextdev--pdp__accordion-sign', 'nextdev--pdp__accordion-body--open');
      });
    });
  })();
})();

/* Award seal: the award windows, one per seal. The popover attribute opens and
   closes it; what the script adds is where it stands from 750 up: under
   whatever opened it, its right edge on the band's, or its left edge where the
   line starts, kept 16 inside the screen, above the opener when there is no
   room below, and moved with the page while it is open. On a phone the css
   makes it a sheet and the script stays out of the way. It works inside one
   section's root, so two sections on one page each place their own panel, and
   it sets up again when the theme editor draws a section anew. */
(function () {
  'use strict';
  var GAP = 10;
  var EDGE = 16;
  var wide = window.matchMedia('(min-width: 750px)');

  // one window per seal: the picture's and the Award block's each open their own
  function setupPanel(root, panel) {
    if (panel.dataset.nextdevPdpAwardInit || typeof panel.showPopover !== 'function') return;
    panel.dataset.nextdevPdpAwardInit = '1';
    var openers = root.querySelectorAll('[data-nextdev-pdp-award-open][popovertarget="' + panel.id + '"]');
    var anchor = null;

    function place() {
      if (!anchor || !wide.matches) {
        panel.style.removeProperty('top');
        panel.style.removeProperty('left');
        return;
      }
      var a = anchor.getBoundingClientRect();
      var w = panel.offsetWidth;
      var h = panel.offsetHeight;
      var fromRight = !anchor.classList.contains('nextdev--pdp__award--line');
      var left = fromRight ? a.right - w : a.left;
      left = Math.max(EDGE, Math.min(left, window.innerWidth - w - EDGE));
      var top = a.bottom + GAP;
      if (top + h > window.innerHeight - EDGE && a.top - GAP - h > EDGE) top = a.top - GAP - h;
      panel.style.left = Math.round(left) + 'px';
      panel.style.top = Math.round(top) + 'px';
    }

    Array.prototype.forEach.call(openers, function (opener) {
      // a click is heard before the popover acts on it, so this names the
      // opener in time for the panel to be placed under it
      opener.addEventListener('click', function () { anchor = opener; });
    });
    panel.addEventListener('toggle', function (event) {
      var open = event.newState === 'open';
      if (open) place();
      Array.prototype.forEach.call(openers, function (o) {
        o.setAttribute('aria-expanded', open && o === anchor ? 'true' : 'false');
      });
    });
    function follow() { if (panel.isConnected && panel.matches(':popover-open')) place(); }
    window.addEventListener('scroll', follow, { passive: true });
    window.addEventListener('resize', follow);
  }

  function setup(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-nextdev-pdp-award-panel]'), function (panel) {
      setupPanel(root, panel);
    });
  }

  function start(scope) {
    var roots = (scope || document).querySelectorAll('[data-nextdev-pdp]');
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})();

// The free line's counter (block low_stock): "for the next N orders", a
// number that drops by one to three every three to seven seconds from
// data-start to data-end. Each visitor keeps their number for eight hours in
// a cookie named by the line's data-block, nextdev-free-bed-<product id>, so
// a reload does not put it back up, and a landing page selling the same
// product reads the same cookie and shows the same number. The line stays
// hidden until its number is known.
(function () {
  'use strict';

  var HOURS = 8;

  function read(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var eq = parts[i].indexOf('=');
      if (parts[i].slice(0, eq) === name) {
        var n = parseInt(decodeURIComponent(parts[i].slice(eq + 1)), 10);
        return isNaN(n) ? null : n;
      }
    }
    return null;
  }

  function write(name, value, expires) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  function setup(line) {
    if (line.dataset.nextdevPdpCounterInit) return;
    var number = line.querySelector('.countdown-number');
    var key = line.dataset.block;
    if (!number || !key) return;
    line.dataset.nextdevPdpCounterInit = '1';

    var start = parseInt(number.dataset.start, 10);
    var end = parseInt(number.dataset.end, 10);
    var repeat = number.dataset.repeat === 'true';
    var expires = new Date(Date.now() + HOURS * 60 * 60 * 1000).toUTCString();
    var value = read(key);
    if (value == null) {
      value = parseInt(number.innerText, 10);
      write(key, value, expires);
    }
    number.innerText = value;
    line.classList.remove('hidden');

    (function tick() {
      setTimeout(function () {
        if (!line.isConnected) return;
        var before = value;
        if (value > end) {
          value = Math.max(end, value - (Math.floor(Math.random() * 3) + 1));
        } else if (repeat) {
          value = start;
        }
        if (value !== before) {
          number.innerText = value;
          number.classList.add('animate');
          setTimeout(function () { number.classList.remove('animate'); }, 1000);
          write(key, value, expires);
        }
        tick();
      }, (Math.floor(Math.random() * 5) + 3) * 1000);
    })();
  }

  function start(scope) {
    var lines = (scope || document).querySelectorAll('[data-nextdev-pdp] .nextdev--pdp__free-bed[data-block]');
    Array.prototype.forEach.call(lines, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})();
